import { useState } from "react";
import { DialogsProps } from "../components/dialogs";


export function useDialogs() {

  const [dialog, setDialog] = useState<DialogsProps>({
    open: false,
    title: "",
    message: "",
    type: 'info',
    style: 'info',
    onCancel: () => { },
    onConfirm: () => { }
  });

  const showConfirmation = (data: Pick<DialogsProps, 'title' | 'message' | 'onConfirm' | 'onCancel'>) => {
    setDialog({
      ...dialog,
      ...data,
      open: true,
      style: 'warning',
      type: 'confirm',
      onCancel: data.onCancel === undefined ? () => {
        setDialog({
          ...dialog,
          open: false
        })
      } : data.onCancel
    });
  };


  const showSuccess = (data: Pick<DialogsProps, 'title' | 'message' | 'onConfirm'>) => {
    setDialog({
      ...dialog,
      ...data,
      open: true,
      style: 'success',
      type: 'info',
      onConfirm: data.onConfirm === undefined ? () => {
        setDialog({
          ...dialog,
          open: false
        });
      } : data.onConfirm
    });
  };

  const showError = (data: Pick<DialogsProps, 'title' | 'message' | 'onConfirm'>) => {
    setDialog({
      ...dialog,
      ...data,
      open: true,
      style: 'error',
      type: 'info',
      onConfirm: data.onConfirm === undefined ? () => {
        setDialog({
          ...dialog,
          open: false
        })
      } : data.onConfirm
    });
  };

  const showWarning = (data: Pick<DialogsProps, 'title' | 'message' | 'onConfirm'>) => {
    setDialog({
      ...dialog,
      ...data,
      open: true,
      style: 'warning',
      type: 'info',
      onConfirm: data.onConfirm === undefined ? () => {
        setDialog({
          ...dialog,
          open: false
        })
      } : data.onConfirm
    });
  };

  const close = () => {
    setDialog((prev) => ({ ...prev, open: false }));
  };

  return {
    dialog,
    showConfirmation,
    showSuccess,
    showError,
    showWarning,
    close,
  };
}
